import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as l, createElementVNode as s } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconMusicOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ s("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M10.823 1.119A.5.5 0 0 1 11 1.5V8c0 .053-.002.106-.006.158a.5.5 0 0 1-.997-.078 1 1 0 0 0-1.075-1.077.5.5 0 0 1-.076-.997A2.021 2.021 0 0 1 10 6.268V2.09l-5.092.848a.5.5 0 1 1-.165-.986l5.675-.946a.5.5 0 0 1 .405.112Zm-9.676.028a.5.5 0 0 1 .707 0l9 9a.5.5 0 1 1-.707.707l-.873-.872a2 2 0 0 1-2.256-2.255L5 5.706V9a2 2 0 1 1-1-1.732v-2.56L1.147 1.853a.5.5 0 0 1 0-.707ZM4 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z",
  "clip-rule": "evenodd"
}, null, -1), f = [
  _
];
function u(e, m, i, p, h, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--music-off"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Music Off",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, f, 10, c);
}
const I = /* @__PURE__ */ n(o, [["render", u]]);
export {
  I as default
};
//# sourceMappingURL=music-off.js.map
